import { createContext, use } from 'react';
import type { AnalyticsActionType } from '@/app/shared/types/analytics';
import { initialAnalyticsState } from '../context/analyticsReducer';

export interface AnalyticsContextType {
  analyticsState: typeof initialAnalyticsState;
  dispatch: (action: AnalyticsActionType) => void;
}

export const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);

export const useAnalyticsContext = (): AnalyticsContextType => {
  const context = use(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalyticsContext must be used within AnalyticsProvider');
  }
  return context;
};
